import * as React from 'react';
import {
  Baby16,
  Book16,
  ChildPlayground16,
  CommerceObject16,
  FastService16,
  Fitness16,
  Hospital16,
  MetroMoscow16,
  Office16,
  Pet16,
  Pool16,
  Restaurant16,
  SPA16,
  SportPlayground16,
  Store16,
  Wood16,
} from '@cian/ui-kit/icons';
import { IIconProps } from '@cian/ui-kit/icons/internal';
import { ENewbuildingInfrastructures } from '../types/infrastructure';

export const INFRASTRUCTURE_ICON_MAP: { [id: number]: React.ReactNode } = {
  [ENewbuildingInfrastructures.School]: <Book16 />,
  [ENewbuildingInfrastructures.Kindergarten]: <Baby16 />,
  [ENewbuildingInfrastructures.Polyclinic]: <Hospital16 />,
  [ENewbuildingInfrastructures.Children]: <ChildPlayground16 />,
  [ENewbuildingInfrastructures.Sport]: <SportPlayground16 />,
  [ENewbuildingInfrastructures.Recreation]: <Wood16 />,
  [ENewbuildingInfrastructures.Dogs]: <Pet16 />,
  [ENewbuildingInfrastructures.Supermarket]: <Store16 />,
  [ENewbuildingInfrastructures.Restaurant]: <Restaurant16 />,
  [ENewbuildingInfrastructures.Fitness]: <Fitness16 />,
  [ENewbuildingInfrastructures.Spa]: <SPA16 />,
  [ENewbuildingInfrastructures.Pool]: <Pool16 />,
  [ENewbuildingInfrastructures.Domestic]: <FastService16 />,
  [ENewbuildingInfrastructures.Commerce]: <CommerceObject16 />,
  [ENewbuildingInfrastructures.Offices]: <Office16 />,
};

export const INFRASTRUCTURE_MAP_ICON_MAP = new Map<string, React.FunctionComponent<IIconProps>>([
  ['cafe', Restaurant16],
  ['clinic', Hospital16],
  ['grocery', Store16],
  ['metro', MetroMoscow16],
  ['nursery', Baby16],
  ['school', Book16],
]);
